import Button from "common/components/Button/Button"
import { withFormik } from "formik"
import { useSelector } from "hooks/useSelector"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { globalSelector } from "routes/globalSlice"
import * as Yup from "yup"
import {
  newDocumentoSelector,
  taxesDefaultSaved,
} from "../redux/selectors/newDocumentoSelectors"
import { setShowRetencion } from "../redux/slices/newDocumentoSettingsSlice"
import {
  recalculate,
  setRetencionPorcentaje,
  setRetencionTipoId,
} from "../redux/slices/newDocumentoSlice"
import ImpuestosForm from "./ImpuestosForm"

const Retencion = ({
  handleSubmit,
  values,
  setFieldValue,
  onHide,
  isValid,
  isLibrado,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const tiposImpuestosGenerales =
    useSelector(globalSelector)?.tiposImpuestosGenerales
  const taxesFormatted = tiposImpuestosGenerales.map(
    (impuesto: $TSMigrationFixMe) => ({
      ...impuesto,
      label: `${impuesto.nombre}`,
      value: impuesto.id,
      fieldValue: impuesto.valor,
    })
  )

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <ImpuestosForm
            isLibradoDoc={isLibrado}
            isRetencion
            values={values}
            setFieldValue={setFieldValue}
            dropdownId='retencionTipoId'
            inputId='retencionPorcentaje'
            title={`${t("crear.facturaRec.modal.holdLabel")} (%)`}
            inpuestosList={taxesFormatted}
            dropdownValue={values.retencionTipoId}
          />
        </div>
      </div>

      <div className='mt-4 col'>
        <div className='row justify-content-end align-items-center'>
          <a
            role='button'
            href='#'
            className='mr-3 link-cancel'
            onClick={onHide}
          >
            {t("crear.facturaRec.modal.cancelButton")}
          </a>

          <Button
            className='!tw-bg-primary'
            type='submit'
            disabled={!isValid}
          >
            {t("crear.facturaRec.modal.addButton")}
          </Button>
        </div>
      </div>
    </form>
  )
}

const validate = Yup.object().shape({
  retencionPorcentaje: Yup.number().required(),
})

const CreateWithFormik = withFormik({
  validationSchema: validate,
  validateOnMount: true,
  // @ts-expect-error TS(2339): Property 'retencionTipoId' does not exist on type ...
  mapPropsToValues: ({ retencionTipoId, retencionPorcentaje }) => {
    return {
      retencionTipoId,
      retencionPorcentaje,
    }
  },
  handleSubmit: ({ retencionTipoId, retencionPorcentaje }, { props }) => {
    // @ts-expect-error TS(2339): Property 'setRetencionTipoId' does not exist on ty...
    props.setRetencionTipoId(retencionTipoId)
    // @ts-expect-error TS(2339): Property 'setRetencionPorcentaje' does not exist o...
    props.setRetencionPorcentaje(retencionPorcentaje)
    // @ts-expect-error TS(2339): Property 'recalculate' does not exist on type 'obj...
    props.recalculate()
    // @ts-expect-error TS(2339): Property 'setShowRetencion' does not exist on type...
    props.setShowRetencion(true)
    // @ts-expect-error TS(2339): Property 'onHide' does not exist on type 'object'.
    props.onHide()
  },
})(Retencion)

const mapStateToProps = (state: $TSMigrationFixMe) => ({
  retencionTipoId: newDocumentoSelector(state).retencionTipoId,
  retencionPorcentaje: newDocumentoSelector(state).retencionPorcentaje,
  taxes: taxesDefaultSaved(state),
})

const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => ({
  setRetencionPorcentaje: (retencionPorcentaje: $TSMigrationFixMe) =>
    dispatch(setRetencionPorcentaje(retencionPorcentaje)),
  setRetencionTipoId: (retencionTipoId: $TSMigrationFixMe) =>
    dispatch(setRetencionTipoId(retencionTipoId)),
  recalculate: () => dispatch(recalculate()),
  setShowRetencion: (show: $TSMigrationFixMe) =>
    dispatch(setShowRetencion(show)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateWithFormik)
